export default "__VITE_ASSET__CIaENZqq__"